<template>
    <div class="p-animated-calc">
        <div class="p-animated-calc__container all-cols">

            <div class="p-animated-calc__column-two--large--cover"></div>

            <svg viewBox="0 0 230.4 120" class="p-animated-calc__logo">
                <use xlink:href="#logo"></use>
            </svg>
            
            <!--column 1-->
            <div class="p-animated-calc__column-one--small">
                <div class="p-animated-calc__column-one--small--cover"></div>
                <router-link :to="'/mini-calculators/'">
                    <div class="p-animated-calc__top-menu">
                        <svg viewBox="0 0 120 120" class="m-mini-calc-icon">
                            <use xlink:href="#dashboard"></use>
                        </svg>
                    </div>
                </router-link>
                <slot name="summary-panel">
                </slot>
            </div>

            <!--column 2-->
            <div class="p-animated-calc__column-two--large" id="print-panel">
                <mini-calculator-print/>
                <div class="flex-grid--vertical p-animated-calc__summary-panel">
                    <div>
                        <h2 class="prompt">
                            Your Calculation
                        </h2>
                        <p>
                            Your calculation will appear here once all mandatory fields have been completed.
                        </p>
                    </div>
                </div>
                <slot name="results-panel">
                </slot>
            </div>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';
    import {mapGetters, mapActions} from 'vuex';
    import Vue from 'vue';
    import miniCalcIcons from 'components/Icons.vue';
    import MiniCalculatorPrint from 'pages/mini-calculators/components/MiniCalculatorPrint';
    /**
     * Component which creates a Mini Calculator Page.
     */
    export default {
        name: 'mini-calculator-page',
        computed: {
            totalInputs: {
                get() {
                    return this.calculator.totalInputs;
                }
            }
        },
        methods: {
            getRange() {
                return _.range(1, this.totalInputs + 1);
            }
        },
        components: {
            miniCalcIcons,
            MiniCalculatorPrint
        },
    }
</script>


// WEBPACK FOOTER //
// MiniCalculatorPageAlternativeWidth.vue?4e30ff32